import { onMounted, watch } from 'vue';
import { mtsEmitter } from '@mts/utils';

export * from './useActionHandler';
export * from './useHiPrint';
export * from './useHiPrintNew';
export * from './usePageModal';
export * from './useRenderForm';
export * from './useRenderTable';
export * from './useSchema';
export * from './useSchemaContext';

export const useSchemaRender = <T = Recordable>(
  props: { schema: T },
  render: (schema: T) => void,
) => {
  onMounted(() => {
    watch(
      () => props.schema,
      (value, oldValue) => {
        // console.log('>> 获取到schema: ', { ...value });
        value && JSON.stringify(value) !== JSON.stringify(oldValue) && render(value);
      },
      { deep: true, immediate: true },
    );
  });

  // 监听多语言变更
  mtsEmitter.on('localeChanged', () => render(props.schema));
};
